import { getLocationWithinDocument } from './getLocationWithinDocument';
import { getSourceUrl } from './getSourceUrl';
import { cleanAndTruncateSourceText } from './sourceTextUtils';
export function formatSourcesForCopy(sourcesSections) {
  const allSources = [];
  sourcesSections.forEach(section => {
    section.sources.forEach(source => {
      var _source$data, _source$data2;
      const url = getSourceUrl(source);
      allSources.push({
        primaryText: cleanAndTruncateSourceText(source.primaryText, (_source$data = source.data) === null || _source$data === void 0 ? void 0 : _source$data.source),
        secondaryText: cleanAndTruncateSourceText(source.secondaryText, (_source$data2 = source.data) === null || _source$data2 === void 0 ? void 0 : _source$data2.source),
        locationText: getLocationWithinDocument(source),
        url
      });
    });
  });
  return allSources.map((source, index) => {
    const parts = [];
    if (source.primaryText) {
      parts.push(source.primaryText);
    }
    if (source.secondaryText) {
      parts.push(source.secondaryText);
    }
    if (source.locationText) {
      parts.push(source.locationText);
    }
    if (source.url) {
      parts.push(source.url);
    }
    return `${index + 1}. ${parts.join(' | ')}`;
  }).join('\n');
}